export enum ImageOrientation {
    LargeHorizontal = 'scss-large-horizontal-image',
    LargeVertical = 'scss-large-vertical-image',
    RegularHorizontal = 'scss-regular-horizontal-image',
    RegularVertical = 'scss-regular-vertical-image'
}
